// 参数设置 重构  fuck  date:2022 03 03


import httpRequest from '@/utils/request.js';

/**查询左侧列表 */
export const paramList = (params = {}) => httpRequest.httpGet({
  url: '/service/param/type/page', params: {
    ...params
  }
})
/**查询右侧侧列表 */
export const paramContentList = (params = {}) => httpRequest.httpGet({
  url: '/service/param/content/list', params: {
    ...params
  }
})
/**添加左侧 */
export const paramContentAdd = (data, loadingOptions) => httpRequest.httpPost('/service/param/type/add', data, loadingOptions
)
/**修改左侧 */
export const paramContentUpdate = (data, loadingOptions) => httpRequest.httpPut('/service/param/type/update', data, loadingOptions
)
/**添加右侧 */
export const paramContentAddR = (data, loadingOptions) => httpRequest.httpPost('/service/param/content/add', data, loadingOptions
)
/**修改右侧 */
export const paramContentUpdateR = (data, loadingOptions) => httpRequest.httpPut('/service/param/content/update', data, loadingOptions
)
/**查询一条 */
export const paramContentUpdateOne = (params = {}) => httpRequest.httpGet({url:'/service/param/content/detail', params:{
  ...params
}
})
/**行拖拽 */
export const paramContentUpdateSeq = (params = {}) => httpRequest.httpGet({url:'/service/param/content/seq', params:{
  ...params
}
})
// /**左侧校验 */
// export const paramContentCheck= (data, loadingOptions) => httpRequest.httpPost('/service/param/type/check', data, loadingOptions
// )
/**右侧校验 */
// export const paramContentCheckR= (data, loadingOptions) => httpRequest.httpPost('/service/param/content/check', data, loadingOptions
// )
/** 左侧删除 */
export const paramContentDel = (data, loadingOptions) => httpRequest.httpdelete('/service/param/type/del', data, loadingOptions)
/** 右侧删除 */
export const paramContentDelR = (data, loadingOptions) => httpRequest.httpdelete('/service/param/content/del', data, loadingOptions)

/**
 * 根据内容code查询单条参数内容（公开接口，免登录）
 * 用于 App 下载等场景
 */
export const getPublicContentByCode = (code) => httpRequest.httpGet({
  url: '/service/param/content/public',
  params: { code }
})